import { render } from "./CustomerSegment.vue?vue&type=template&id=775dc6a8&scoped=true"
import script from "./CustomerSegment.vue?vue&type=script&lang=js"
export * from "./CustomerSegment.vue?vue&type=script&lang=js"

import "./CustomerSegment.vue?vue&type=style&index=0&id=775dc6a8&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775dc6a8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInput,QTd,QMenu,QList,QItem,QAvatar,QItemSection,QSeparator});qInstall(script, 'directives', {ClosePopup});
